<template>
  <div class="rate">
    <div
      class="rate-item"
      v-for="(v, i) in list"
      :key="i"
    >
      <img
        class="rate-item__icon"
        :src="mapStar[type].default"
      >
      <img
        :style="{
          width: `${v}em`
        }"
        class="rate-item__icon rate-item__icon--full"
        :src="mapStar[type].full"
      >
    </div>
  </div>
</template>

<script setup>
import greyStar from '@/assets/colorIcon/star-grey.svg'
import blackStar from '@/assets/colorIcon/star-black.svg'
import emptyStar from '@/assets/colorIcon/star-empty.svg'
import yellowStar from '@/assets/colorIcon/star.svg'

const props = defineProps({
  value: {
    type: [Number, String],
    required: true
  },
  count: {
    type: Number,
    default: 5
  },
  type: {
    type: String,
    default: 'yellow',
    validator: (value) => {
      return ['yellow', 'black'].includes(value)
    }
  }
})

const mapStar = {
  yellow: {
    default: emptyStar,
    full: yellowStar
  },
  black: {
    default: greyStar,
    full: blackStar
  }
}

const list = computed(() => {
  const result = []
  let value = Number(props.value)
  for (let i = 0; i < props.count; i++) {
    if (value >= 1) {
      result.push(1)
      value -= 1
    } else if (value > 0) {
      result.push(value)
      value = 0
    } else {
      result.push(0)
    }
  }
  return result
})
</script>

<style lang="less" scoped>
.rate {
  display: flex;

  &-item {
    position: relative;
    width: 1em;
    height: 1em;

    &__icon {
      display: block;
      width: 100%;
      height: 100%;

      &--full {
        position: absolute;
        top: 0;
        left: 0;
        object-position: left;
        object-fit: cover;
      }
    }
  }
}
</style>
